import clsx from 'clsx'
import styles from './Titre.module.css'
import {
  isMobile
} from 'react-device-detect'

const Titre = ({ state }) => {
  return (
    <h1
      className={
        clsx({
          [styles.titre]: true,
          [styles.mobile]: isMobile
        })
      }
    >
      Password Generator ({state.n + state.l + state.u + state.s})
    </h1>
  )
}

export default Titre
